import { Availability } from '../types/availability';

export const getColor = (availability: Availability) =>
  availability === Availability.AVAILABLE
    ? '#4CA800'
    : availability === Availability.RESERVED
    ? '#CC8500'
    : '#E60000';
